export const UPDATE_NEWSITEM = "UPDATE_NEWSITEM";
export const SET_NEWSITEM = "SET_NEWSITEM";
export const SET_NEWS = "SET_NEWS";
export const LIST_NEWS = "LIST_NEWS";
export const LOAD_NEWSITEM = "LOAD_NEWSITEM";
export const SAVE_NEWSITEM = "SAVE_NEWSITEM";
export const REMOVE_NEWSITEM = "REMOVE_NEWSITEM";
